import { List } from "immutable";

export interface IUPCData {
    [key: string]: {
        display_name: string;
        value: string;
    };
}

export interface IUPCDataFromUpload {
    [key: string]: string;
}

export interface IIdentifierFields {
    display_name: string;
    key: string;
}

export enum UPCRuleType {
    RequiredColumnsRule = "required-columns-rule",
    NotEmptyRule = "not-empty-rule",
    UPCNumericRule = "upc-numeric-rule",
    UPCScientificRule = "upc-scientific-rule",
    RequiredValuesRule = "required-value-rule",
    ProductIdentifierMatchRule = "product-identifier-match-rule",
    GenericError = "generic-error",
}

export type IUPCDataError = {
    [UPCRuleType.RequiredColumnsRule]?: string;
    [UPCRuleType.NotEmptyRule]?: string;
    [UPCRuleType.UPCNumericRule]?: string[];
    [UPCRuleType.UPCScientificRule]?: string[];
    [UPCRuleType.RequiredValuesRule]?: string[];
    [UPCRuleType.ProductIdentifierMatchRule]?: string[];
    [UPCRuleType.GenericError]?: string;
};

export type ProductDataMap = Map<string, Map<string, Map<string, string>>>;

export type ProductList = List<ProductDataMap>;

export interface INewUpcsByProductId {
    [productId: string]: string;
}
